export class ImpactAssessmentDetailT6ListModel {
    summary: Array<ItemDetailList>;
    intialImpactAssessment: Array<ItemDetailList>;
    reviewDetails:Array<ItemDetailList>;
    stakeholderImpactAssessment:Array<ItemDetailList>;
    implementationDetails: Array<ItemDetailList>;


    constructor() {
        this.summary = [];
        this.intialImpactAssessment = [];
        this.reviewDetails=[];
        this.stakeholderImpactAssessment=[];
        this.implementationDetails = [];
    }
}

export class ItemDetailList {
    itemTitle: string;
    createdOn: Date;

    constructor() {
        this.itemTitle = '';
        this.createdOn = new Date();
    }
}
